/* Utils */
import { generateSelectEntityById } from '../utils/generators/selectorGenerators';

export const selectAllShows = (state) => state.shows;

export const selectShowById = generateSelectEntityById(selectAllShows);
